import {objectFromEntries} from '@benchling/js-utils';

import {AnalyticsMetadataForContext} from 'analytics/AnalyticsTypes';
import {BioentityInfo} from 'folder-items/FileConstants';
import {makeArchiveItemsActionFunction} from 'notebook/structured-tables/action-functions/archiveItemsActionFunction';
import {
  OverflowMenuActionFunction,
  TableActionFunctionParameters,
  ToolbarButtonActionFunction,
} from 'notebook/structured-tables/StructuredTableConstants';

// exported only for tests
export function getItemsToArchive<TTableMetadata, TRowMetadata>(
  params: TableActionFunctionParameters<TTableMetadata, TRowMetadata>
): Array<BioentityInfo & {rowId: string}> {
  // Object.values() turns the dictionary back into an array
  return Object.values(
    // objectFromEntries() builds a dictionary with id as key to de-duplicate
    objectFromEntries(
      params.structuredTable.rows.flatMap(
        (row, rowIndex): Array<[string, BioentityInfo & {rowId: string}]> =>
          row.cells
            .flatMap((cell, cellIndex): Array<BioentityInfo & {rowId: string}> => {
              const typedValue = cell.typedValue ?? params.computedTable[rowIndex][cellIndex].value;
              if (typedValue == null || params.liveRowMetadataByRow?.[rowIndex].archivePurpose != null) {
                return [];
              } else if (typedValue.type === 'BIOENTITY') {
                return [{...typedValue.bioentitySummary, rowId: row.rowId}];
              } else {
                return [];
              }
            })
            .map((bioentityInfo) => [bioentityInfo.id, bioentityInfo])
      )
    )
  );
}

export function makeArchiveBioentitiesActionFunction<TTableMetadata, TRowMetadata>({
  analyticsActionForPerfTracking,
  analyticsMetadata,
}: {
  analyticsActionForPerfTracking: string;
  analyticsMetadata: AnalyticsMetadataForContext;
}): ToolbarButtonActionFunction<TTableMetadata, TRowMetadata> &
  OverflowMenuActionFunction<TTableMetadata, TRowMetadata> {
  return makeArchiveItemsActionFunction({
    itemsFriendlyPlural: 'entities',
    getItemsToArchive,
    analyticsMetadata,
    analyticsActionForPerfTracking,
  });
}
